import { daysSince } from './listingMath.ts';

interface ListingAgeProps {
  firstSeen: string;
  now?: Date;
}

/**
 * Listing age: whole days since first_seen. An old listing whose price just
 * dropped is the strongest buy signal this data carries, so age stays
 * visible next to the price.
 */
export default function ListingAge({ firstSeen, now = new Date() }: ListingAgeProps) {
  const days = daysSince(firstSeen, now);
  if (days === null) {
    return <span className="text-gray-400">—</span>;
  }
  const tone =
    days >= 14 ? 'text-gray-500' : days >= 7 ? 'text-gray-700' : 'text-gray-900 font-medium';
  return (
    <span className={tone} title={`First seen ${firstSeen}`}>
      {days === 0 ? 'today' : `${days}d`}
    </span>
  );
}
